<div id="yoga-meditation" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">

        <h2 class="title">Yoga and Meditation</h2>

        <h4 class="mt-3 mb-3" style="color: var(--primary); font-weight:600;">
          “Unleash the Power of Zen for a Better Tomorrow”
        </h4>

        <p class="inner-lead">
          Shah Satnam Ji Girls’ College recognizes the importance of physical, mental, and spiritual well-being in the holistic development of our students. Our yoga and meditation program is designed to help students achieve a sense of balance, inner peace, and physical fitness. We regularly organize yoga and meditation sessions led by experienced instructors, where students learn various asanas, pranayama, and meditation techniques. These sessions help students reduce stress, improve concentration, and enhance their overall well-being. Our college also celebrates International Yoga Day with great enthusiasm, organizing various yoga-related activities and programs. By promoting the practice of yoga and meditation, we aim to equip our students with valuable tools for maintaining a healthy and balanced lifestyle in today’s fast-paced world.
        </p>

        <h5 class="mt-4" style="font-weight: 600;">Objectives:</h5>
        <ul class="inner-lead">
          <li>To promote physical, mental, and spiritual well-being among students.</li>
          <li>To help students achieve inner peace and emotional balance through yoga and meditation.</li>
          <li>To improve concentration and reduce stress among students for better academic performance.</li>
          <li>To cultivate a healthy and disciplined lifestyle through regular yoga practice.</li>
        </ul>

        <h5 class="mt-4" style="font-weight: 600;">The Practice:</h5>
        <ul class="inner-lead">
          <li><strong>Daily Yoga Sessions:</strong> Conducting regular yoga and meditation classes for students and staff.</li>
          <li><strong>Special Workshops:</strong> Organizing sessions with expert yoga practitioners on advanced techniques and benefits.</li>
          <li><strong>Yoga Day Celebration:</strong> Commemorating International Yoga Day with college-wide events and activities.</li>
          <li><strong>Dedicated Space:</strong> Providing a serene and well-equipped environment for yoga and meditation practice.</li>
        </ul>

      </div>
    </div>
  </div>
</div>
